import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';

@Component({
    selector: 'app-register-layout',
    templateUrl: './register-layout.component.html',
    styleUrl: './register-layout.component.scss',
})
export class RegisterLayoutComponent implements OnInit {
    hideBackButton = false;

    constructor(
        private activatedRoute: ActivatedRoute,
        private router: Router,
    ) {}

    ngOnInit(): void {
        this.hideBackButton = this.activatedRoute.firstChild?.firstChild?.firstChild?.snapshot.data['hideBackButton'];

        if (this.hideBackButton) {
            return;
        }

        this.router.events.forEach((event) => {
            if (event instanceof NavigationStart) {
                if (event.navigationTrigger === 'popstate') {
                    this.router.navigate(['/login']);
                }
            }
        });
    }
}
